export const styles: { [key: string]: React.CSSProperties } = {
  pausedOverlay: {
    position: "absolute",
    top: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "72px",
    fontWeight: "bold",
    color: "white",
    WebkitTextStroke: "1px black",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    zIndex: 1000,
  },
};
